import React, {
  useEffect,
  useState,
  useRef,
  useContext,
  useReducer,
} from "react";

import axios from "axios";

import { Button } from "@material-ui/core";

const { REACT_APP_ECLIPSE_API_PUBLIC, REACT_APP_ECLIPSE_API } = process.env;

export default function COM_Upload_IMG({
  P_dirPath,
  P_fileName,
  P_BtnLable = "",
  p_resize = 1024,
  P_quality = 80,
  c_CallBack,
  thumb_size = "20rem",
  thumb_height = "20rem",
  thumb_fontsize = "1em",
  disabled = false,
}) {
  // ---------------------------------- global var

  // const P_dirPath = useRef(`./uploads/Eclipse_GSM/noticeboard/`);
  // const P_fileName = useRef(`myfilename000.jpg`);
  const [fileExists, setFileExists] = useState(false);
  const [uploadStatus, setUploadStatus] = useState("");
  const local_P_fileName = useRef("");
  const fileType = useRef(P_fileName?.split(".").at(-1));

  // ----------------------------------

  const [img, setImg] = useState("https://fakeimg.pl/50x50/?text=Upload Image");
  // const [saveImg, setSaveImg] = useState(null);
  const saveImg = useRef(null);

  function handleUploadChange(e) {
    // console.log("handleUploadChange", e.target.files[0]);
    let uploaded = e.target.files[0];
    setImg(URL.createObjectURL(uploaded));
    // setSaveImg(uploaded);
    saveImg.current = uploaded;

    // setTimeout(() => {
    uploadImage();
    // }, 3000);
  }

  function uploadImage() {
    // if (!saveImg) {
    //   alert("Pls Choose a File");
    // } else {
    // ----------------------------------  sent file to server

    let formData = new FormData();
    formData.append("file", saveImg.current);
    formData.append("dirpath", P_dirPath);
    formData.append("filename", local_P_fileName.current);
    formData.append("resize", p_resize);
    formData.append("quality", P_quality);
    formData.append("create_SmallImg", false); // api default is true, need to manually set false
    // console.log("P_fileName 111", P_fileName); // testing
    // console.log("formData", formData);
    // console.log("saveImg", saveImg.current);
    // console.log("local_P_fileName.current", local_P_fileName.current);

    setUploadStatus("Uploading...");
    console.log("p0");
    axios({
      method: "post",
      // url: `http://localhost:7000/api/upload/upload_test`,
      url: `${REACT_APP_ECLIPSE_API}/api/upload/upload_IMG_v2`,
      data: formData,

      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function (res) {
        console.log("p1 a", res.data);
        //handle success
        if (res.data.status === true) {
          setUploadStatus("Upload Completed!");
          console.log("#### Upload Completed!");
          c_CallBack("child egg22");
        }
        console.log("p1 b", res.data);
      })
      .catch(function (res) {
        console.log("p2 a", res.data);

        //handle error
        if (res.data?.status === false) {
          setUploadStatus("Upload Failed!");
        }
        console.log("p2 b", res);
      });

    // fetch("http://localhost:7000/api/upload", {
    //   method: "POST",
    //   body: formData,
    // })
    //   .then((res) => res.json())
    //   .then((data) => {
    //     if (data.status === "success") {
    //       window.location.href = data.image;
    //     }
    //   });
    // }
  }

  const testUrl_Exists = () => {
    setUploadStatus("checking file exists");
    axios
      .get(
        `${REACT_APP_ECLIPSE_API}/testURLExist?url=${
          REACT_APP_ECLIPSE_API +
          P_dirPath.substring(1) +
          local_P_fileName.current
        }`
      )
      .then((res) => {
        // console.log("testUrl_Exists", res.data);
        setFileExists(res.data);
        if (res.data === true) {
          setImg(
            `${
              REACT_APP_ECLIPSE_API +
              P_dirPath.substring(1) +
              local_P_fileName.current
            }?dummy=${Math.random()}`
          );
          setUploadStatus("File Exist");
        } else {
          setUploadStatus("File NOT exist");
        }

        // this.setState({ fileExists: res.data });
      })
      .catch((err) => {
        console.log("ERR", err);
      });
  };

  useEffect(() => {
    // console.log("P_fileName 0a", P_fileName); // testing

    local_P_fileName.current = P_fileName;
    testUrl_Exists();
  }, []);

  useEffect(() => {
    // console.log("P_fileName 0b", P_fileName); // testing

    local_P_fileName.current = P_fileName;
  }, [P_fileName]);

  return (
    <div
      className="COM_FileUpload_FlexColumn COM_FileUpload_Btn_Container"
      style={{
        width: thumb_size,
        // backgroundColor: "red"
      }}
    >
      <img
        className="COM_FileUpload_IMG"
        style={{ height: thumb_height }}
        src={img}
        onClick={() => {
          window.open(img);
        }}
      />

      {fileExists === false ? (
        // <div className="Global_Flex_Column_Pure">
        <input
          type="file"
          id={`formFile_${P_fileName}`}
          className="COM_FileUpload_Btn_Input"
          accept="image/*"
          onChange={(e) => {
            handleUploadChange(e);
          }}
        />
      ) : (
        // </div>
        // <div className="COM_FileUpload_FlexColumn ">
        <input
          type="file"
          id={`formFile_${P_fileName}`}
          // id="formFile"
          className="COM_FileUpload_Btn_Input"
          accept="image/*"
          onChange={(e) => {
            handleUploadChange(e);
          }}
        />
        // </div>
      )}
      <div className="COM_FileUpload_IMG_Text">🔍VIEW FILE</div>
      {disabled !== true ? (
        <label for={`formFile_${P_fileName}`}>
          {fileExists === false ? (
            <div
              className="COM_FileUpload_Btn"
              style={{ fontSize: thumb_fontsize }}
            >
              <div className="COM_FileUpload_Btn_Text_File_Exist">
                Upload (auto compress): {fileType.current}
              </div>
              {uploadStatus === "Uploading..." ||
              uploadStatus === "File NOT exist" ? (
                <div style={{ color: "red" }}>{`👨‍🦯${uploadStatus}`}</div>
              ) : (
                <div style={{ color: "yellowgreen" }}>
                  {`🪙${uploadStatus}, ${p_resize}x${p_resize},${P_quality}% , ${
                    disabled === true ? "👁️View Only" : "✏️Editable"
                  }`}
                </div>
              )}
              <div className="COM_FileUpload_Label">{P_BtnLable}</div>
            </div>
          ) : (
            <div
              className="COM_FileUpload_Btn"
              style={{ fontSize: thumb_fontsize }}
            >
              <div className="COM_FileUpload_Btn_Text_File_NotExist">
                Re-Upload (auto compress): {fileType.current}
              </div>
              {uploadStatus === "Uploading..." ||
              uploadStatus === "File NOT exist" ? (
                <div style={{ color: "red" }}>{`👩‍🦯${uploadStatus}`}</div>
              ) : (
                <div style={{ color: "yellowgreen" }}>
                  {`🪙${uploadStatus}, ${p_resize}x${p_resize},${P_quality}% , ${
                    disabled === true ? "👁️View Only" : "✏️Editable"
                  }`}
                </div>
              )}

              <div className="COM_FileUpload_Label">{P_BtnLable}</div>
            </div>
          )}
        </label>
      ) : (
        ""
      )}
    </div>
  );
}
